/** High-frequency controls kept visible in the screener filter rail. */

import type { ScreenerFilterState } from "../../lib/types";
import { FILTER_CONTROL_CONFIG } from "./filter-control-config";
import { DateRange, FilterSection, NumberRange, OptionButtons } from "./filter-fields";

interface PrimaryFilterControlsProps {
  filters: ScreenerFilterState;
  onFilterPatch: (filters: Partial<ScreenerFilterState>) => void;
}

/** Renders filing date, signal, and transaction value controls. */
export function PrimaryFilterControls({ filters, onFilterPatch }: PrimaryFilterControlsProps) {
  return (
    <>
      <DateRange
        label="Filing date"
        from={filters.filingDateFrom}
        to={filters.filingDateTo}
        onFromChange={(filingDateFrom) => onFilterPatch({ filingDateFrom })}
        onToChange={(filingDateTo) => onFilterPatch({ filingDateTo })}
      />
      <FilterSection label="Signal">
        <OptionButtons
          options={FILTER_CONTROL_CONFIG.signals}
          selected={filters.signalBuckets}
          ariaLabelPrefix="Signal"
          onChange={(signalBuckets) => onFilterPatch({ signalBuckets })}
        />
      </FilterSection>
      <NumberRange
        label="Transaction value"
        minimum={filters.minTransactionValue}
        maximum={filters.maxTransactionValue}
        onMinimumChange={(minTransactionValue) => onFilterPatch({ minTransactionValue })}
        onMaximumChange={(maxTransactionValue) => onFilterPatch({ maxTransactionValue })}
      />
    </>
  );
}
